// Section 22 explainability: <Num> asks for a Target's factor list only when its tooltip opens.
// app.tsx provides the explainer (the store's game and run config); components never read signals.
import { createContext } from 'preact';
import type { Target } from '../../sim/api';
import type { TooltipVM } from '../../viewModels';

export type Explainer = (target: Target) => TooltipVM | null;

export const ExplainContext = createContext<Explainer>(() => null);
